export const DASHBOARD_ROUTE_ROOT = '/dashboard';

export const DASHBOARD_ROUTES = {
  SUMMARY: DASHBOARD_ROUTE_ROOT,
  ORDER_ITEM: `${DASHBOARD_ROUTE_ROOT}/order-item`,
  USERS: `${DASHBOARD_ROUTE_ROOT}/users`,
  REPLENISH_ITEM: `${DASHBOARD_ROUTE_ROOT}/replenish-item`,
  STOCK_TRANSFER_ITEM: `${DASHBOARD_ROUTE_ROOT}/bin-transfer-item`,
  PRODUCT_UPLOAD: `${DASHBOARD_ROUTE_ROOT}/product-upload`,
  USER_UPLOAD: `${DASHBOARD_ROUTE_ROOT}/user-upload`,
  PHARMACY_UPLOAD: `${DASHBOARD_ROUTE_ROOT}/pharmacy-upload`,
  COMPANY_INFO: `${DASHBOARD_ROUTE_ROOT}/company-info`,
  BINS: `${DASHBOARD_ROUTE_ROOT}/bins`,
  INVENTORY_ADJUSTMENT: `${DASHBOARD_ROUTE_ROOT}/inventory-adjustment`,
  STO: `${DASHBOARD_ROUTE_ROOT}/sto`,
  INBOUND: `${DASHBOARD_ROUTE_ROOT}/inbound`,
  DELIVERY_NOTE: `${DASHBOARD_ROUTE_ROOT}/delivery-note`,
} as const;
